import React from 'react';
import classNames from 'classnames';

import 'components/input/input.scss';
import { isDesktopSafari } from '../../utils/browser';

interface inputProps {
  hasError?: boolean;
  onChange?: (event: React.SyntheticEvent<{ value: string }>) => void;
  onKeyDown?: (event: React.SyntheticEvent<{ value: string }>) => void;
  onKeyUp?: (event: React.SyntheticEvent<{ value: string }>) => void;
  value?: string;
  label?: string;
  extraClassesInput?: string;
  type?: string;
  min?: string;
}

const defaultProps: inputProps = {
  hasError: false,
  value: '',
  label: '',
  min: ''
};

class Input extends React.Component<inputProps> {
  public static defaultProps: inputProps = defaultProps;

  dateInput: React.RefObject<HTMLInputElement> = React.createRef();
  // If we have a date input and it has a picker attribute bind the event
  componentDidMount() {
    const input = this.dateInput.current;

    if (input && isDesktopSafari()) {
      input.addEventListener('change', this.dateChangeHandler);
    }
  }

  // Cleanup before re-render
  componentWillUnmount() {
    const input = this.dateInput.current;

    if (input && isDesktopSafari()) {
      input.removeEventListener('change', this.dateChangeHandler);
    }
  }

  dateChangeHandler = event => {
    // console.log('date change handler');
    if (this.props.onChange) this.props.onChange(event);
  };

  render() {
    const props = this.props;
    const onKeyDown = e => {
      if (props.type === 'number') {
        const key = e.which || e.keyCode;
        // dot, minus, comma, comma keypad, minus keypad, plus keypad
        if (
          key === 190 ||
          key === 188 ||
          key === 189 ||
          key === 110 ||
          key === 107 ||
          key === 109 ||
          key === 187
        ) {
          e.preventDefault();
          return;
        }
      }
      if (typeof props.onKeyDown === 'function') props.onKeyDown(e);
    };
    return (
      <label className={classNames('c-input c-input__label')}>
        {props.label}

        <input
          className={classNames('c-input__element', props.extraClassesInput, {
            'c-input--error': props.hasError
          })}
          ref={props.type === 'date' && this.dateInput}
          min={props.min}
          type={props.type}
          onKeyUp={props.onKeyUp}
          onKeyDown={e => onKeyDown(e)}
          onChange={props.onChange}
          value={props.value}
        />
        <div className={classNames('c-input__wrapper')} />
      </label>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/input/input.tsx